var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1047,
    height: 988,
    viewBox: "0 0 1047 988",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.628 971.086C223.828 977.062 198.365 981.262 152.033 990.226L0.576586 332.111C-2.22672 319.916 5.48239 307.802 17.3964 305.703C61.1591 297.95 103.987 291.004 147.127 284.705C158.418 283.09 168.93 291.166 170.721 302.876L270.706 971.086H270.628Z",
    fill: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.764 956.789C381.121 959.05 355.502 961.15 308.391 966.399L231.222 387.187C229.587 375.073 237.997 363.847 249.755 362.636C290.792 358.275 332.375 354.964 373.879 352.702C385.326 352.056 395.137 361.263 395.838 373.135L427.842 956.789H427.764Z",
    fill: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.674 23.5214L585.464 955.332C560.468 954.525 542.948 954.202 525.583 954.202C508.218 954.202 490.775 954.525 465.779 955.332L429.57 23.5214C429.103 11.4074 438.291 1.23159 449.894 0.908552C500.197 -0.302851 550.89 -0.302851 601.272 0.908552C612.952 1.23159 622.063 11.4074 621.596 23.5214H621.674Z",
    fill: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.151 146.61L742.9 966.488C695.789 961.158 670.17 959.139 623.526 956.877L668.769 131.024C669.391 118.99 679.359 109.865 690.961 110.591C738.54 113.66 785.573 117.456 833.385 122.059C845.221 123.19 853.786 134.416 852.151 146.691V146.61Z",
    fill: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.44 350.61L892.181 1021C817.945 986.704 780.827 969.556 780.827 969.556L877.775 321.698C879.41 310.957 888.988 303.365 899.422 304.819C943.263 310.715 987.337 317.821 1031.1 326.059C1042.08 328.159 1049.09 339.384 1046.44 350.61Z",
    fill: "#E7D4A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarBackground);
export default __webpack_public_path__ + "static/media/bar-background.8a3dca57aeb03a3e3d97232038b26fd4.svg";
export { ForwardRef as ReactComponent };